module.exports = __webpack_public_path__ + "img/solution-data-img1.259dcfb0.png";